import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const XPLORE_THEME = {
  name: 'xplore_default',
  base: 'default',
  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
